export default __webpack_public_path__ + "static/media/p5-3.6323ba69.png";